import { DataChannel } from './channel';

export const templateChannel = {
  saved: new DataChannel<number>(),
  deleted: new DataChannel<boolean>(),
};
